import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useIntroComplete } from '../context/IntroContext';
import { getCookieConsent, loadGoogleAfterConsent } from '../utils/cookieConsent';
import { trackPageView } from './googleAnalytics';

/** Tracks SPA route changes in GA4 after intro + cookie consent. */
const AnalyticsRouteTracker: React.FC = () => {
  const location = useLocation();
  const introComplete = useIntroComplete();

  useEffect(() => {
    if (getCookieConsent() === 'accepted') {
      loadGoogleAfterConsent();
      if (introComplete) {
        trackPageView(`${location.pathname}${location.search}`);
      }
    }
  }, [introComplete, location.pathname, location.search]);

  return null;
};

export default AnalyticsRouteTracker;
